const createMemoryStorage = (): Storage => {
  const store: Record<string, string> = {};
  return {
    get length() {
      return Object.keys(store).length;
    },
    clear() {
      Object.keys(store).forEach((key) => delete store[key]);
    },
    getItem(key: string) {
      return Object.prototype.hasOwnProperty.call(store, key)
        ? store[key]
        : null;
    },
    key(index: number) {
      const keys = Object.keys(store);
      return keys[index] ?? null;
    },
    removeItem(key: string) {
      delete store[key];
    },
    setItem(key: string, value: string) {
      store[key] = value;
    },
  };
};

const memoryStorage = createMemoryStorage();

export const ensureLocalStorageSafely = () => {
  if (typeof globalThis !== 'object' || globalThis === null) {
    return;
  }

  let storage: Storage | null = null;
  try {
    storage =
      typeof globalThis.localStorage === 'undefined'
        ? null
        : globalThis.localStorage;
  } catch {
    storage = null;
  }

  if (storage) return;

  try {
    Object.defineProperty(globalThis, 'localStorage', {
      configurable: true,
      value: memoryStorage,
    });
  } catch {
    // If localStorage is not configurable, there's nothing more we can do.
  }
};
